import { render, staticRenderFns } from "./ProfileDocumentUpload.vue?vue&type=template&id=2be3e570&"
import script from "./ProfileDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./ProfileDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports